module.exports = __webpack_public_path__ + "static/media/betlogo.da4aaebb.png";